import { AIIntegrations } from "./components/ai-integrations";
import { BrandMarquee } from "./components/brand-marquee";
import {
  MotionPreferences,
  useForwardProgress,
} from "./components/motion-preferences";
import { motion, useScroll } from "framer-motion";
import { Nav } from "./components/nav";
import { Hero } from "./components/hero";
import { Intro } from "./components/intro";
import { Services } from "./components/services";
import { WhyUs } from "./components/why-us";
import { Process } from "./components/process";
import { FAQ } from "./components/faq";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";
import { useTheme } from "./hooks/use-theme";

function Site() {
  const { theme, toggleTheme } = useTheme();
  const { scrollYProgress } = useScroll();
  const scaleX = useForwardProgress(scrollYProgress);
  return (
    <>
      <div className="site-shell" data-theme={theme}>
        <a className="skip-link" href="#main">
          Skip to content
        </a>
        <motion.div
          className="reading-progress"
          style={{ scaleX }}
          aria-hidden="true"
        />
        <Nav theme={theme} toggleTheme={toggleTheme} />
        <main id="main">
          <Hero />
          <BrandMarquee />
          <Intro />
          <Services />
          <AIIntegrations />
          <WhyUs />
          <Process />
          <FAQ />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}
function App() {
  return (
    <MotionPreferences>
      <Site />
    </MotionPreferences>
  );
}
export default App;
